<template>
  <v-dialog :value="conflict.show" persistent max-width="480">
    <v-card>
      <v-card-title class="text-h6 font-weight-bold">
        Bank account already in use
      </v-card-title>
      <v-card-text class="black--text">
        <div class="font-weight-medium">This bank account number is already in use for :-</div>
        <ul class="mt-2 mb-0">
          <li v-for="(user, i) in matchedUsers" :key="i">
            {{ accountUserLabel(user) }}
          </li>
        </ul>
        <div class="mt-3 font-weight-medium">Do you still want to continue?</div>
      </v-card-text>
      <v-card-actions class="pb-4 px-4">
        <v-spacer />
        <v-btn text @click="respond(false)">No</v-btn>
        <v-btn color="primary" depressed @click="respond(true)">Yes, continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AccountConflictDialog",
  computed: {
    ...mapGetters({ conflict: "accountConflict/getAccountConflict" }),
    // All matched users (other customers + this customer's earlier records),
    // formatted the same way as the search panel via accountUserLabel().
    matchedUsers() {
      return this.accountMatchList(this.conflict);
    },
  },
  methods: {
    respond(value) {
      this.$store.dispatch("accountConflict/respond", value);
    },
  },
};
</script>
